import React, { Component } from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';

export default class NavBarComp extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false,
            setIsOpen: false
        }
    }

    toggle() {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }
    isOpen() {

    }


    render() {
        return (
            <div style={{ textAlign: "center" }}>
                <Navbar expand="xl" >
                    <NavbarBrand className="navibarBrand" style={{ fontWeight: "bold" }} href="/">S & I Commercial</NavbarBrand>
                    <NavbarToggler onClick={this.toggle} />
                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="mr-auto" navbar>
                            <NavItem className="naviItem" >
                                <NavLink href="/">Home</NavLink>
                            </NavItem>
                            <NavItem className="naviItem">
                                <NavLink href="/about">Find Us</NavLink>
                            </NavItem>
                            <NavItem className="naviItem">
                                <NavLink href="/contact">Contact</NavLink>
                            </NavItem>
                            <NavItem className="naviItem">
                                <NavLink href="/repairs">Repairs</NavLink>
                            </NavItem>
                            <NavItem className="naviItem">
                                <NavLink href="/recovery">Recovery</NavLink>
                            </NavItem>
                            <NavItem className="naviItem">
                                <NavLink href="/tyres">Tyres</NavLink>
                            </NavItem>
                            <NavItem className="naviItem">
                                <NavLink href="/sales">Sales</NavLink>
                            </NavItem>
                        </Nav>

                    </Collapse>

                </Navbar>
            </div>
        )
    }
}

